export default __webpack_public_path__ + "static/media/hire.16d2d6e5.png";